import React from 'react';
import PropTypes from 'prop-types';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';
import { renderKr } from 'utils/renderingService';
import theme from 'theme';

const PenlyPlayDevelopmentGraph = ({ data }) => {

    // eslint-disable-next-line prefer-spread
    const minAge = Math.min.apply(Math, data.values.map((x) =>
        Math.min(x.age),
    ));

    // eslint-disable-next-line prefer-spread
    const maxAge = Math.max.apply(Math, data.values.map((x) =>
        Math.max(x.age),
    ));

    // eslint-disable-next-line prefer-spread
    const expectedPensionAtPension = Math.max.apply(Math, data.values.map((x) =>
        Math.max(x.value),
    ));

    const renderAge = value => {
        if (value === minAge || value === maxAge) return `${Math.floor(value)} år`;
        return value;
    };

    const pensionAgeEstimated = () => {
        let pensionAge = data.pensionAgeEstimated > maxAge ? maxAge : data.pensionAgeEstimated;
        pensionAge = pensionAge < minAge ? minAge : pensionAge;
        return pensionAge;
    };

    const toKr = (value, small) => value && `${renderKr(value, undefined, undefined, undefined, small === true)}`;
    const renderToolTipAge = value => {
        if (value) return `${Math.floor(value)} år`;
        return '';
    };

    const renderLegendText = (value, entry) => <span style={{ color: 'black', fontWeight: 400, marginLeft: '5px' }}>{ value }</span>;

    const CustomizedYAxisTick = props => {
        const { x, y, payload } = props;

        return (
            <g transform={ `translate(${x},${y})` }>
                <text x={ 0 } y={ 3 } dx={ 0 } textAnchor="end" style={{ fontWeight: 'bold', fontSize: 14 }}>
                    { toKr(payload.value) }
                </text>
                { payload.value === data.pensionSavedToDate ?
                    (
                        <text x="0" y={ 0 } dx={ 0 } dy={ 18 } textAnchor="end" style={{ fontSize: 12 }}>
                            Opsparet til dato
                        </text>
                    )
                    :
                    (
                        <>
                            <text x="0" y={ 0 } dx={ 0 } dy={ 18 } textAnchor="end" style={{ fontSize: 12 }}>
                                Opsparet ved
                            </text>
                            <text x="0" y={ 0 } dx={ 0 } dy={ 34 } textAnchor="end" style={{ fontSize: 12 }}>
                                pension
                            </text>
                        </>
                    ) }
            </g>
        );
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={ data.values }
                width={ 595 }
                height={ 350 }
            >
                <XAxis
                    dataKey="age"
                    interval="preserveStartEnd"
                    axisLine={ false }
                    tickLine={ false }
                    minTickGap={ 15 }
                    tick={{ fontSize: '14px', fontWeight: '500' }}
                    tickFormatter={ renderAge }
                    dy={ 10 }
                />
                <YAxis
                    tick={ <CustomizedYAxisTick /> }
                    interval="preserveEnd"
                    axisLine={ false }
                    tickLine={ false }
                    ticks={ [data.pensionSavedToDate, expectedPensionAtPension] }
                    width={ 95 }
                    type="number"
                />

                <Tooltip formatter={ toKr } labelFormatter={ renderToolTipAge } />
                <CartesianGrid horizontal={ false } stroke={ '#D3D3D3' } />
                <ReferenceLine
                    stroke="#47858940"
                    strokeWidth={ 3 }
                    segment={ [
                        {
                            x: minAge,
                            y: expectedPensionAtPension,
                        },
                        {
                            x: pensionAgeEstimated(),
                            y: expectedPensionAtPension,
                        },
                    ] }
                />
                <Line name="Pensionsalder" dataKey={ null } stroke="#EF9761" />
                <Line name="Din pension" type="monotone" dot={ false } dataKey="value" stroke="#478589" strokeWidth="3" />
                <ReferenceLine x={ pensionAgeEstimated() } stroke="#EF9761" strokeWidth={ 3 } />
                <Legend
                    iconType="plainline"
                    iconSize={ 20 }
                    wrapperStyle={{ transform: 'translate(0, 25px)' }}
                    formatter={ renderLegendText } />
            </LineChart>
        </ResponsiveContainer>
    );
};

PenlyPlayDevelopmentGraph.defaultProps = {};

PenlyPlayDevelopmentGraph.propTypes = {};

export default PenlyPlayDevelopmentGraph;
